// src/pages/players/PublicExamPlay.jsx
import { useMemo } from "react"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import ExamPlay from "@/exam/pages/ExamPlay"
import { ExamProvider } from "@/exam/context"
import { createPublicProvider } from "@/exam/provider"

export default function PublicExamPlay() {
  const { orgId, runId } = useParams()
  const [sp] = useSearchParams()
  const preview = sp.get("preview") === "1" || sp.get("mode") === "test"
  const nav = useNavigate()
  const provider = useMemo(() => createPublicProvider({ orgId, runId, preview }), [orgId, runId, preview])
  return (
    <ExamProvider provider={provider}>
      <ExamPlay
        onResult={({ submissionId, score, full }) => {
          const qs = new URLSearchParams({ score: String(score), full: String(full), ...(preview ? { preview: "1" } : {}) })
          nav(`/play/${orgId}/${runId}/result/${submissionId}?${qs.toString()}`)
        }}
      />
    </ExamProvider>
  )
}
